module.exports = __webpack_public_path__ + "static/media/bdt-genetica-logo.ad145a35.png";